/* Ajuste a la tarjeta (Xavi, 20/10/2026): el cliente ve su diseño dentro de la tarjeta con la línea de corte,
   la sangre y la zona segura; puede rellenar o ajustar, hacer zoom y mover; la sangre se genera alargando el borde
   (mismo color que el fondo) y se avisa si hay texto o logo a menos de 3 mm del corte.
   Sirve para PNG/JPG/WebP y para PDF (se dibuja la primera página). Lo que se envía al pedido es el archivo ya
   a medida (medida + 2 mm de sangre por lado, a 300 ppp); el original viaja aparte. */
(function () {
  'use strict';

  var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
  var PDFJS_WORKER = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
  var pdfjsP = null;
  function cargarPdfjs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (pdfjsP) return pdfjsP;
    pdfjsP = new Promise(function (ok, no) {
      var s = document.createElement('script'); s.src = PDFJS; s.async = true;
      s.onload = function () { try { window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER; ok(window.pdfjsLib); } catch (e) { no(e); } };
      s.onerror = function () { pdfjsP = null; no(new Error('pdfjs')); };
      document.head.appendChild(s);
    });
    return pdfjsP;
  }

  var SANGRE = 2;      // mm de sangre que generamos por cada lado
  var SEGURA = 3;      // mm por dentro del corte donde no debe haber texto ni logo
  var PPP = 300;       // resolución del archivo que se genera
  var MAX_PX = 5000;   // lado largo máximo al leer un archivo (memoria)

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function fmt(n, d) { return Number(n).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: d == null ? 1 : d }); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ---------- leer el archivo a un lienzo ---------- */
  function lienzoDeImagen(file) {
    return createImageBitmap(file).then(function (bmp) {
      var e = Math.min(1, MAX_PX / Math.max(bmp.width, bmp.height));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(bmp.width * e)); c.height = Math.max(1, Math.round(bmp.height * e));
      c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
      if (bmp.close) bmp.close();
      return { lienzo: c, textos: null, mm: null };
    });
  }

  function lienzoDePdf(file) {
    return cargarPdfjs().then(function (lib) {
      return file.arrayBuffer().then(function (buf) { return lib.getDocument({ data: buf }).promise; });
    }).then(function (doc) {
      return doc.getPage(1);
    }).then(function (pg) {
      var vp1 = pg.getViewport({ scale: 1 });
      var wmm = vp1.width * 25.4 / 72, hmm = vp1.height * 25.4 / 72;
      var esc = Math.min(PPP / 72 * 1.34, MAX_PX / Math.max(vp1.width, vp1.height));  // ~400 ppp
      var vp = pg.getViewport({ scale: esc });
      var c = document.createElement('canvas');
      c.width = Math.round(vp.width); c.height = Math.round(vp.height);
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
      return pg.render({ canvasContext: ctx, viewport: vp }).promise.then(function () {
        return pg.getTextContent().then(function (tc) {
          var t = [];
          tc.items.forEach(function (it) {
            if (!it.str || !it.str.trim()) return;
            var x0 = it.transform[4], y0 = it.transform[5], w = it.width || 0, h = it.height || Math.abs(it.transform[3]) || 0;
            // de puntos PDF (origen abajo) a píxeles del lienzo (origen arriba)
            t.push({ x0: x0 * esc, x1: (x0 + w) * esc, y0: c.height - (y0 + h) * esc, y1: c.height - y0 * esc });
          });
          return { lienzo: c, textos: t, mm: [wmm, hmm] };
        });
      });
    });
  }

  function rotar(c) {
    var r = document.createElement('canvas'); r.width = c.height; r.height = c.width;
    var x = r.getContext('2d'); x.translate(r.width, 0); x.rotate(Math.PI / 2); x.drawImage(c, 0, 0);
    return r;
  }

  /* ---------- el editor ---------- */
  function Ajuste(o) {
    Ajuste.n++;
    this.o = o;                       // {host, file, esPdf, caja:{w,h}, dpiMin, dpiGood, precioRevision, onAplicar, onCerrar}
    this.W = o.caja.w; this.H = o.caja.h;
    this.plegada = !!o.plegada;      // tarjeta de felicitación plegada: el lienzo es la tarjeta ABIERTA y el pliegue está en el centro
    this.modo = 'rellenar'; this.zoom = 1; this.cx = 0; this.cy = 0; this.color = '#ffffff';
    this.yaTrae = 0;                  // mm de sangre que ya trae el archivo (2 o 3), 0 si no
    this.montar();
    this.mudarAFoto();
    this.cargar();
  }

  /* EN PC, EN LA ZONA DE LA FOTO (Xavi, 21/10): como el resto de editores de la tienda, el editor se muda a la columna de la foto del
     producto (que en PC es una foto de archivo que no pinta nada) y se queda pegado al hacer scroll; en móvil se queda dentro del formulario.
     Es UN solo bloque que cambia de sitio. */
  Ajuste.prototype.mudarAFoto = function () {
    var host = this.o.host, col = document.querySelector('.product__media-wrapper, .product__media-gallery');
    if (!col || !host.parentNode || !window.matchMedia) return;
    var marca = document.createComment('ajuste'), self = this, ancha = window.matchMedia('(min-width: 990px)');
    host.parentNode.insertBefore(marca, host);
    var colocar = function () {
      if (ancha.matches) {
        if (host.parentNode !== col) col.insertBefore(host, col.firstChild);
        host.classList.add('tjs-aj--media'); col.classList.add('tjs-galeria-oculta');
      } else {
        if (host.parentNode === col && marca.parentNode) marca.parentNode.insertBefore(host, marca.nextSibling);
        host.classList.remove('tjs-aj--media'); col.classList.remove('tjs-galeria-oculta');
      }
    };
    this.foto = { col: col, marca: marca, ancha: ancha, colocar: colocar };
    if (ancha.addEventListener) ancha.addEventListener('change', colocar); else if (ancha.addListener) ancha.addListener(colocar);
    colocar();
  };

  Ajuste.prototype.destruir = function () {
    var f = this.foto; if (!f) return;
    if (f.ancha.removeEventListener) f.ancha.removeEventListener('change', f.colocar); else if (f.ancha.removeListener) f.ancha.removeListener(f.colocar);
    f.col.classList.remove('tjs-galeria-oculta');
    if (f.marca.parentNode) f.marca.parentNode.removeChild(f.marca);
    this.foto = null;
  };

  Ajuste.prototype.montar = function () {
    var self = this, h = this.o.host;
    h.innerHTML = '';
    h.className = 'tjs-aj';
    this.msg = el('p', 'tjs-aj__msg', 'Leyendo el archivo…');
    this.cuerpo = el('div', 'tjs-aj__cuerpo'); this.cuerpo.hidden = true;
    this.cv = el('canvas', 'tjs-aj__cv');
    var lienzo = el('div', 'tjs-aj__lienzo'); lienzo.appendChild(this.cv);
    this.ctrl = el('div', 'tjs-aj__ctrl');
    this.ctrl.innerHTML =
      '<div class="tjs-aj__fila" data-fila-modo>' +
        '<label><input type="radio" name="tjsm' + Ajuste.n + '" value="rellenar" checked> <b>Rellenar</b> <small>cubre toda la tarjeta</small></label>' +
        '<label><input type="radio" name="tjsm' + Ajuste.n + '" value="ajustar"> <b>Ajustar</b> <small>se ve entero, con margen</small></label>' +
      '</div>' +
      '<div class="tjs-aj__fila" data-fila-zoom><span>Zoom</span><input type="range" min="100" max="300" value="100" data-zoom><button type="button" class="tjs-link" data-centrar>Centrar</button><button type="button" class="tjs-link" data-girar>Girar</button></div>' +
      '<div class="tjs-aj__fila" data-fila-color hidden><span>Color del margen</span><input type="color" value="#ffffff" data-color></div>';
    this.leyenda = el('p', 'tjs-aj__leyenda');
    this.leyenda.innerHTML =
      '<span class="tjs-aj__k tjs-aj__k--corte"></span> corte <span data-med></span> ' +
      '<span class="tjs-aj__k tjs-aj__k--seg"></span> zona segura: texto y logo dentro ' +
      '<span class="tjs-aj__k tjs-aj__k--sangre"></span> lo de fuera se corta (sangre)' +
      (this.plegada ? ' <span class="tjs-aj__k tjs-aj__k--pliegue"></span> pliegue: nada importante a menos de 3 mm' : '');
    this.avisos = el('div', 'tjs-aj__avisos');
    this.btns = el('div', 'tjs-aj__btns');
    this.bAplicar = el('button', 'tjs-fix', 'Usar este ajuste'); this.bAplicar.type = 'button';
    this.bCerrar = el('button', 'tjs-fix tjs-fix--gris', 'Cerrar'); this.bCerrar.type = 'button';
    this.btns.appendChild(this.bAplicar); this.btns.appendChild(this.bCerrar);
    this.cuerpo.appendChild(lienzo);
    this.cuerpo.appendChild(this.ctrl); this.cuerpo.appendChild(this.leyenda);
    this.cuerpo.appendChild(this.avisos); this.cuerpo.appendChild(this.btns);
    h.appendChild(this.msg); h.appendChild(this.cuerpo);

    var q = function (s) { return self.ctrl.querySelector(s); };
    this.rModos = [].slice.call(this.ctrl.querySelectorAll('input[type=radio]'));
    this.rModos.forEach(function (r) { r.addEventListener('change', function () { self.modo = r.value; self.zoom = 1; self.cx = 0; self.cy = 0; self.sincronizar(); self.pintar(); }); });
    this.rZoom = q('[data-zoom]');
    this.rZoom.addEventListener('input', function () { self.zoom = parseInt(self.rZoom.value, 10) / 100; self.limitar(); self.pintar(); });
    q('[data-centrar]').addEventListener('click', function () { self.cx = 0; self.cy = 0; self.pintar(); });
    q('[data-girar]').addEventListener('click', function () { self.girar(); });
    this.iColor = q('[data-color]');
    this.iColor.addEventListener('input', function () { self.color = self.iColor.value; self.pintar(); });
    this.bAplicar.addEventListener('click', function () { self.aplicar(); });
    this.bCerrar.addEventListener('click', function () { self.cerrar(); });

    // arrastrar para mover
    var arr = null;
    this.cv.addEventListener('pointerdown', function (e) {
      if (self.yaTrae) return;
      arr = { x: e.clientX, y: e.clientY, cx: self.cx, cy: self.cy };
      try { self.cv.setPointerCapture(e.pointerId); } catch (x) { }
      e.preventDefault();
    });
    this.cv.addEventListener('pointermove', function (e) {
      if (!arr) return;
      var mmPx = (self.W + 2 * self.B) / self.cv.getBoundingClientRect().width;
      self.cx = arr.cx + (e.clientX - arr.x) * mmPx; self.cy = arr.cy + (e.clientY - arr.y) * mmPx;
      self.limitar(); self.pintar();
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) { self.cv.addEventListener(ev, function () { arr = null; }); });
  };
  Ajuste.n = 0;

  Ajuste.prototype.cargar = function () {
    var self = this;
    var p = this.o.esPdf ? lienzoDePdf(this.o.file) : lienzoDeImagen(this.o.file);
    p.then(function (r) {
      self.S = r.lienzo; self.textos = r.textos; self.mmPdf = r.mm;
      self.detectar();
      self.msg.hidden = true; self.cuerpo.hidden = false;
      self.sincronizar(); self.pintar();
      try { self.o.host.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) { }
    }).catch(function () {
      self.msg.hidden = false;
      self.msg.textContent = 'No hemos podido abrir ese archivo aquí. Súbelo igualmente: lo revisamos en el taller.';
    });
  };

  /* ¿ya viene con sangre (medida + 2 o + 3 mm)? ¿gira? */
  Ajuste.prototype.detectar = function () {
    var S = this.S, r = S.width / S.height, W = this.W, H = this.H, b;
    var tol = this.mmPdf ? 0.0 : 0.003;     // imagen: proporción casi exacta (el A4 y el A4 con sangre se parecen un 0,5 %); PDF: se mide en milímetros
    var cerca = function (x) { return Math.abs(r - x) / x <= tol; };
    var mmPdf = this.mmPdf, medido = function (ww, hh) {
      var a = mmPdf[0], c = mmPdf[1];
      return (Math.abs(a - ww) <= 0.8 && Math.abs(c - hh) <= 0.8) || (Math.abs(a - hh) <= 0.8 && Math.abs(c - ww) <= 0.8);
    };
    var enc = function (W2, H2) {
      var m = [[SANGRE, 2], [3, 3]], i;
      for (i = 0; i < m.length; i++) {
        var s = 2 * m[i][0];
        if (mmPdf ? medido(W2 + s, H2 + s) : cerca((W2 + s) / (H2 + s))) return m[i][1];
      }
      return 0;
    };
    // vertical en una tarjeta horizontal (o al revés): la tarjeta se trabaja girada
    var vert = this.plegada ? false : (r < 1) !== (W / H < 1);
    this.vertical = vert;
    if (vert) { var t = W; W = H; H = t; }
    this.W = W; this.H = H;
    b = enc(W, H);
    this.yaTrae = b;
    this.B = b || SANGRE;
    this.sinSangre = !b && (mmPdf ? medido(W, H) : cerca(W / H));
  };

  Ajuste.prototype.girar = function () {
    this.S = rotar(this.S);
    if (this.mmPdf) this.mmPdf = [this.mmPdf[1], this.mmPdf[0]];
    if (this.textos) {
      var h = this.S.width; // tras girar: nuevo ancho = antiguo alto
      this.textos = this.textos.map(function (t) { return { x0: h - t.y1, x1: h - t.y0, y0: t.x0, y1: t.x1 }; });
    }
    this.W = this.o.caja.w; this.H = this.o.caja.h; this.zoom = 1; this.cx = 0; this.cy = 0;
    this.detectar();
    this.sincronizar(); this.pintar();
  };

  Ajuste.prototype.sincronizar = function () {
    var f = this.ctrl.querySelector('[data-fila-modo]'), z = this.ctrl.querySelector('[data-fila-zoom]'), c = this.ctrl.querySelector('[data-fila-color]');
    var libre = !this.yaTrae;
    f.hidden = !libre; z.hidden = !libre; c.hidden = !(libre && this.modo === 'ajustar');
    this.rZoom.min = this.modo === 'ajustar' ? 40 : 100;
    this.rZoom.max = 300;
    this.rZoom.value = Math.round(this.zoom * 100);
    var med = this.leyenda.querySelector('[data-med]'); if (med) med.textContent = '(' + fmt(this.W / 10, 1) + ' × ' + fmt(this.H / 10, 1) + ' cm)';
    this.bAplicar.textContent = this.yaTrae ? 'Usar tal cual' : 'Usar este ajuste';
    if (this.yaTrae) this.bAplicar.className = 'tjs-fix';
    this.rModos.forEach(function (r) { /* el modo ya está marcado */ });
  };

  /* rectángulo de la imagen en mm, con el origen en la esquina del corte */
  Ajuste.prototype.rect = function () {
    var S = this.S, W = this.W, H = this.H, sw = S.width, sh = S.height;
    if (this.yaTrae) { var b = this.yaTrae; return { x: -b, y: -b, w: W + 2 * b, h: H + 2 * b }; }
    var base = this.modo === 'ajustar' ? Math.min(W / sw, H / sh) : Math.max(W / sw, H / sh);
    var esc = base * this.zoom, w = sw * esc, h = sh * esc;
    return { x: W / 2 + this.cx - w / 2, y: H / 2 + this.cy - h / 2, w: w, h: h, esc: esc };
  };

  Ajuste.prototype.limitar = function () {
    if (this.yaTrae) return;
    var r = this.rect(), W = this.W, H = this.H;
    if (this.modo === 'rellenar') {
      // el corte siempre cubierto por la imagen
      var maxx = Math.max(0, (r.w - W) / 2), maxy = Math.max(0, (r.h - H) / 2);
      this.cx = clamp(this.cx, -maxx, maxx); this.cy = clamp(this.cy, -maxy, maxy);
    } else {
      // entera dentro del corte
      var mx = Math.max(0, (W - r.w) / 2), my = Math.max(0, (H - r.h) / 2);
      this.cx = clamp(this.cx, -mx, mx); this.cy = clamp(this.cy, -my, my);
    }
  };

  /* dibuja la tarjeta (corte + sangre) en un lienzo a k píxeles por mm */
  Ajuste.prototype.dibujar = function (k) {
    var B = this.B, W = this.W, H = this.H, S = this.S;
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round((W + 2 * B) * k)); c.height = Math.max(1, Math.round((H + 2 * B) * k));
    var x = c.getContext('2d'); x.imageSmoothingQuality = 'high';
    x.fillStyle = this.modo === 'ajustar' && !this.yaTrae ? this.color : '#ffffff';
    x.fillRect(0, 0, c.width, c.height);
    var r = this.rect();
    var rx = (r.x + B) * k, ry = (r.y + B) * k, rw = r.w * k, rh = r.h * k;
    if (this.modo !== 'ajustar' || this.yaTrae) {
      // la sangre: se alarga el borde de la imagen hacia fuera (mismo color que el fondo)
      var sw = S.width, sh = S.height, rr = rx + rw, rb = ry + rh;
      if (rx > 0) x.drawImage(S, 0, 0, 1, sh, 0, ry, rx, rh);
      if (rr < c.width) x.drawImage(S, sw - 1, 0, 1, sh, rr, ry, c.width - rr, rh);
      if (ry > 0) x.drawImage(S, 0, 0, sw, 1, rx, 0, rw, ry);
      if (rb < c.height) x.drawImage(S, 0, sh - 1, sw, 1, rx, rb, rw, c.height - rb);
      if (rx > 0 && ry > 0) x.drawImage(S, 0, 0, 1, 1, 0, 0, rx, ry);
      if (rr < c.width && ry > 0) x.drawImage(S, sw - 1, 0, 1, 1, rr, 0, c.width - rr, ry);
      if (rx > 0 && rb < c.height) x.drawImage(S, 0, sh - 1, 1, 1, 0, rb, rx, c.height - rb);
      if (rr < c.width && rb < c.height) x.drawImage(S, sw - 1, sh - 1, 1, 1, rr, rb, c.width - rr, c.height - rb);
    }
    x.drawImage(S, rx, ry, rw, rh);
    return c;
  };

  /* mira qué hay en la zona segura y si el borde es liso */
  Ajuste.prototype.analizar = function (c, k) {
    var B = this.B, W = this.W, H = this.H;
    var d = c.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, c.width, c.height).data;
    var x0 = B * k, y0 = B * k, x1 = (B + W) * k, y1 = (B + H) * k;
    var banda = 0.8 * k, zona = SEGURA * k, px = [], cont = [], i, x, y;
    for (y = Math.floor(y0); y < y1; y += 1) {
      for (x = Math.floor(x0); x < x1; x += 1) {
        var m = Math.min(x - x0, x1 - 1 - x, y - y0, y1 - 1 - y);
        if (m >= zona) { x = Math.max(x, Math.floor(x1 - zona - 1)); continue; }
        var o = (y * c.width + x) * 4;
        var px3 = [d[o], d[o + 1], d[o + 2]];
        if (m < banda) px.push(px3); else cont.push(px3);
      }
    }
    if (!px.length) return { plano: true, contenido: false };
    var med = [0, 1, 2].map(function (ch) { var a = px.map(function (p) { return p[ch]; }).sort(function (u, v) { return u - v; }); return a[a.length >> 1]; });
    var dist = function (p) { return Math.abs(p[0] - med[0]) + Math.abs(p[1] - med[1]) + Math.abs(p[2] - med[2]); };
    var cerca = 0; for (i = 0; i < px.length; i++) if (dist(px[i]) < 60) cerca++;
    var plano = cerca / px.length >= 0.9;
    var lejos = 0; for (i = 0; i < cont.length; i++) if (dist(cont[i]) > 120) lejos++;
    return { plano: plano, contenido: cont.length ? (lejos > 40 && lejos / cont.length > 0.0015) : false };
  };

  Ajuste.prototype.textoFuera = function () {
    if (!this.textos || !this.textos.length) return false;
    var r = this.rect(), W = this.W, H = this.H, S = this.S;
    var esc = r.esc || (r.w / S.width);
    for (var i = 0; i < this.textos.length; i++) {
      var t = this.textos[i];
      var a = r.x + t.x0 * esc, b = r.x + t.x1 * esc, c = r.y + t.y0 * esc, e = r.y + t.y1 * esc;
      if (b > 0 && a < W && e > 0 && c < H && (a < SEGURA || c < SEGURA || b > W - SEGURA || e > H - SEGURA)) return true;
      if (this.plegada && b > W / 2 - SEGURA && a < W / 2 + SEGURA && e > 0 && c < H) return true;
    }
    return false;
  };

  Ajuste.prototype.pintar = function () {
    var k = 8, B = this.B, W = this.W, H = this.H;
    var c = this.dibujar(k);
    var an = this.analizar(c, k);
    var vis = this.cv; vis.width = c.width; vis.height = c.height;
    var x = vis.getContext('2d');
    x.drawImage(c, 0, 0);
    // lo que se corta, apagado
    x.fillStyle = 'rgba(0,0,0,.28)';
    x.fillRect(0, 0, vis.width, B * k); x.fillRect(0, (B + H) * k, vis.width, B * k);
    x.fillRect(0, B * k, B * k, H * k); x.fillRect((B + W) * k, B * k, B * k, H * k);
    // corte
    x.lineWidth = 2; x.strokeStyle = '#e6007e'; x.setLineDash([]);
    x.strokeRect(B * k, B * k, W * k, H * k);
    // zona segura
    x.strokeStyle = '#1873d9'; x.setLineDash([8, 6]);
    x.strokeRect((B + SEGURA) * k, (B + SEGURA) * k, (W - 2 * SEGURA) * k, (H - 2 * SEGURA) * k);
    x.setLineDash([]);
    if (this.plegada) {
      var xp = (B + W / 2) * k;
      x.strokeStyle = '#1a9a3c'; x.lineWidth = 2; x.setLineDash([10, 6]);
      x.beginPath(); x.moveTo(xp, B * k); x.lineTo(xp, (B + H) * k); x.stroke();
      x.strokeStyle = '#1873d9'; x.lineWidth = 1; x.setLineDash([3, 5]);
      [-SEGURA, SEGURA].forEach(function (d) { x.beginPath(); x.moveTo(xp + d * k, (B + SEGURA) * k); x.lineTo(xp + d * k, (B + H - SEGURA) * k); x.stroke(); });
      x.setLineDash([]);
    }
    // textos del PDF que están donde no deben
    if (this.textos && this.textos.length) {
      var r = this.rect(), esc = r.esc || (r.w / this.S.width);
      x.strokeStyle = '#ff7a00'; x.lineWidth = 2;
      for (var i = 0; i < this.textos.length; i++) {
        var t = this.textos[i];
        var a = r.x + t.x0 * esc, b = r.x + t.x1 * esc, cc = r.y + t.y0 * esc, e = r.y + t.y1 * esc;
        if (b > 0 && a < W && e > 0 && cc < H && (a < SEGURA || cc < SEGURA || b > W - SEGURA || e > H - SEGURA || (this.plegada && b > W / 2 - SEGURA && a < W / 2 + SEGURA))) {
          x.strokeRect((B + a) * k, (B + cc) * k, (b - a) * k, (e - cc) * k);
        }
      }
    }
    this.avisar(an);
  };

  Ajuste.prototype.avisar = function (an) {
    var av = [], r = this.rect();
    var dpi = r.esc ? 25.4 / r.esc : (this.S.width / ((this.W + 2 * this.yaTrae) / 25.4));
    var item = function (k, t) { return '<p class="tjs-aj__av tjs-aj__av--' + k + '">' + t + '</p>'; };
    if (this.yaTrae) av.push(item('ok', 'Tu archivo ya trae ' + this.yaTrae + ' mm de sangre. No hace falta cambiar nada.'));
    else if (this.sinSangre && this.modo === 'rellenar' && this.zoom === 1) av.push(item('mid', 'Tu archivo tiene justo la medida, sin sangre: la generamos alargando el borde con el color del fondo.'));
    else if (this.modo === 'rellenar') av.push(item('ok', 'La sangre se genera alargando el borde con el color del fondo.'));
    if (this.vertical) av.push(item('mid', 'Tu diseño es vertical: la tarjeta se imprimirá en vertical (' + fmt(this.W, 1) + ' × ' + fmt(this.H, 1) + ' mm). Si no es lo que quieres, pulsa «Girar».'));
    var txt = this.textoFuera();
    if (txt) av.push(item('low', 'Hay <b>texto a menos de ' + SEGURA + ' mm del borde' + (this.plegada ? ' o del pliegue' : '') + '</b> (marcado en naranja): puede cortarse' + (this.plegada ? ' o quedar en la doblez' : '') + '. Pulsa «Ajustar» o baja el zoom para dejar margen.'));
    else if (an.contenido) av.push(item('low', 'Parece haber <b>texto o logo muy cerca del borde</b>: puede cortarse. Pulsa «Ajustar» para dejar margen.'));
    else if (!txt && !an.contenido) av.push(item('ok', 'Nada importante en el borde.'));
    var revisar = !an.plano && !this.yaTrae && this.modo === 'rellenar';
    if (revisar) av.push(item('mid', 'El borde no es liso (foto o dibujo hasta el borde): al alargarlo puede notarse un estirado.'));
    if (dpi < (this.o.dpiMin || 100)) av.push(item('low', 'Poca resolución (' + Math.round(dpi) + ' ppp a este tamaño): se notará pixelado.'));
    if ((txt || an.contenido || revisar) && this.o.precioRevision) {
      av.push('<p class="tjs-aj__av tjs-aj__av--mid">¿Prefieres que lo ajuste un diseñador? <button type="button" class="tjs-link" data-contratar-revision>Contratar la revisión de archivos · ' + this.o.precioRevision + '</button></p>');
    }
    this.avisos.innerHTML = av.join('');
  };

  Ajuste.prototype.aplicar = function () {
    var self = this;
    if (this.yaTrae) { this.cerrar(); return; }
    var c = this.dibujar(PPP / 25.4);
    c.toBlob(function (blob) {
      if (!blob) return;
      var base = (self.o.file.name || 'diseno').replace(/\.[^.]+$/, '');
      var file = new File([blob], base + '-tarjeta-con-sangre.png', { type: 'image/png' });
      self.o.onAplicar(file, { sangre: SANGRE, modo: self.modo, vertical: self.vertical });
    }, 'image/png');
  };

  Ajuste.prototype.cerrar = function () {
    this.destruir();
    this.o.host.innerHTML = ''; this.o.host.className = '';
    if (this.o.host.parentNode) this.o.host.parentNode.removeChild(this.o.host);
    if (this.o.onCerrar) this.o.onCerrar();
  };

  window.TarjetaAjuste = {
    abrir: function (o) { return new Ajuste(o); },
    // para pruebas
    _Ajuste: Ajuste
  };
})();
